import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { TypeAgenda } from '@/lib/types';

export type AvailableSlot = {
  mecanicienId: string;
  debut: string;
  fin: string;
};

type Params = {
  typeAgenda: TypeAgenda;
  dureeEstimeeMinutes: number;
  mecanicienId?: string;
  dateMin?: string;
  dateMax?: string;
  maxResults?: number;
};

export function useAvailableSlots(params: Params, enabled: boolean) {
  const qs = new URLSearchParams();
  qs.set('typeAgenda', params.typeAgenda);
  qs.set('dureeEstimeeMinutes', String(params.dureeEstimeeMinutes));
  if (params.mecanicienId) qs.set('mecanicienId', params.mecanicienId);
  if (params.dateMin) qs.set('dateMin', params.dateMin);
  if (params.dateMax) qs.set('dateMax', params.dateMax);
  if (params.maxResults) qs.set('maxResults', String(params.maxResults));

  return useQuery({
    queryKey: ['slots', params],
    queryFn: () => api.get<{ slots: AvailableSlot[] }>(`/interventions/slots/available?${qs.toString()}`),
    select: (d) => d.slots,
    enabled: enabled && params.dureeEstimeeMinutes > 0,
    staleTime: 10_000,
  });
}
